<div class="card-preview-container">
  <!-- Modal Header -->
  <div class="preview-header d-flex align-items-center justify-content-between flex-wrap gap-2">
    <div class="preview-title text-truncate">
      <div class="d-flex align-items-center gap-2 flex-wrap">
        <h5 class="mb-0 text-white fw-bold card-name-heading">{{ data.title || 'Card Image Preview' }}</h5>
        <span *ngIf="data.cardNumber" class="card-number-badge">
          {{ data.cardNumber.startsWith('#') ? data.cardNumber : '#' + data.cardNumber }}
        </span>
        <span *ngIf="data.setName" class="set-name-badge">
          <i class="fa-solid fa-layer-group me-1"></i>
          Set: {{ data.setName }}
        </span>
        <span *ngIf="!data.setName && data.subtitle" class="set-name-badge">
          {{ data.subtitle }}
        </span>
      </div>
    </div>
    
    <!-- Toolbar controls -->
    <div class="preview-toolbar d-flex align-items-center gap-2">
      <!-- Zoom controls -->
      <div class="toolbar-group d-flex align-items-center">
        <button type="button" class="btn btn-dark-toolbar" (click)="zoomOut()" title="Zoom Out (-)">
          <i class="fa-solid fa-magnifying-glass-minus"></i>
        </button>
        <span class="zoom-badge">{{ (zoomScale * 100).toFixed(0) }}%</span>
        <button type="button" class="btn btn-dark-toolbar" (click)="zoomIn()" title="Zoom In (+)">
          <i class="fa-solid fa-magnifying-glass-plus"></i>
        </button>
      </div>

      <!-- Rotate controls -->
      <div class="toolbar-group d-flex align-items-center">
        <button type="button" class="btn btn-dark-toolbar" (click)="rotateLeft()" title="Rotate Left">
          <i class="fa-solid fa-rotate-left"></i>
        </button>
        <button type="button" class="btn btn-dark-toolbar" (click)="rotateRight()" title="Rotate Right">
          <i class="fa-solid fa-rotate-right"></i>
        </button>
      </div>

      <!-- Reset button -->
      <button type="button" class="btn btn-dark-toolbar reset-btn" (click)="resetZoom()" title="Reset Zoom">
        <i class="fa-solid fa-rotate me-1"></i> Reset
      </button>

      <!-- Close button -->
      <button type="button" class="btn-close-custom ms-1" (click)="close()" aria-label="Close" title="Close (Esc)">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>
  </div>

  <!-- Image Body -->
  <div class="preview-body text-center d-flex align-items-center justify-content-center">
    <div class="image-wrapper position-relative" [style.transform]="'scale(' + zoomScale + ') rotate(' + rotationAngle + 'deg)'">
      <img [src]="data.imageUrl || 'assets/images/card.svg'" alt="Card Image Preview" class="img-fluid full-card-img" />
    </div>
  </div>
</div>
